import {
  type PointsDisplay,
  pointsDisplayOptions,
} from '../types/canvas-shape.js';

/**
 * Returns true if pointsDisplay is a valid PointsDisplay
 * @param pointsDisplay - points display
 */
export const isValidPointsDisplay = (
  pointsDisplay: string,
): pointsDisplay is PointsDisplay =>
  (pointsDisplayOptions as unknown as string[]).includes(pointsDisplay);
